import { Component } from '@angular/core';
import { E5coreUiWorkTabBaseComponent } from './e5code-ui-work-tab-base';

@Component({
  selector: 'e5core-ui-work-tab-material',
  templateUrl: './e5core-ui-work-tab-material.component.html',
  styleUrls: ['./e5core-ui-work-tab-material.component.css']
})
export class E5coreUiWorkTabMaterialComponent extends E5coreUiWorkTabBaseComponent {

}
